import { type UseQueryResult, useQuery } from 'react-query';
import * as wealthlaneCustomerServices from '@wealthlane/api-services/wealthlane-customer-service';
import { TradeOrderService } from '@wealthlane/api-services/wealthlane-award-settlement-service';
import { TransferAllocateService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetTransferContainerStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const transferContainerStatus = useQuery(
    ['getTransferContainerStatus'],
    async () => {
      return await handleRequest(
        TransferAllocateService.getApiAwardApiAppTransferAllocateContainerStatuses()
      );
    },
    {
      select: (data) => {
        const newData = data?.filter((item) => item.displayName !== 'Draft');
        return newData?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return transferContainerStatus;
};

export default useGetTransferContainerStatus;
